import localAPI from './local.config';

type SetPaymentMethodData = {
  paylineToken: string;
  price: number;
  firstName: string;
  lastName: string;
  addressLineOne: string;
  addressLineTwo?: string;
  city: string;
  state: string;
  zipCode: string;
  phonePrimary: string;
  email: string;
  franchiseeSlug: string;
  vaultId?:string;
  ipAddress?:string;
  shippingAddressOne:string;
  shippingAddressTwo:string;
  shippingCity:string;
  shippingZipCode:string;
  shippingState:string;
}

const setPaymentMethod = async (requestData : SetPaymentMethodData) => {
  const response = localAPI.post('/set-payment-method/', requestData);

  return response;
};

export default setPaymentMethod;
